module.exports = __webpack_public_path__ + "dingbeauty-landing/img/Pro@2.6ab37652.png";